
//TODO
//+ curate lists below
//+ use list as array, an create list as option
//+ dynamically build list from ImPaaS query (not hardcoded)
//+ if format not supported by components, use ImPaaS convert at upload

//TODO input formats

/** Image formats */
export const imageFormats = new Map([
  ['JPEG', {
      description: 'A commonly used method of lossy compression for digital images, particularly for photographs.',
      developer: 'Joint Photographic Experts Group',
      extension: ['.jpg', '.jpeg']
  }],
  ['PNG', {
      description: 'A raster graphics file format that supports lossless data compression and transparency.',
      developer: 'PNG Development Group',
      extension: ['.png']
  }],
  ['GIF', {
      description: 'A bitmap image format that supports both animated and static images, using lossless compression.',
      developer: 'CompuServe',
      extension: ['.gif']
  }],
  ['BMP', {
      description: 'A raster graphics image file format used to store bitmap digital images, independently of the display device.',
      developer: 'Microsoft',
      extension: ['.bmp']
  }],
  ['TIFF', {
      description: 'A flexible format that can store high-quality images, often used in publishing and photography.',
      developer: 'Adobe Systems',
      extension: ['.tiff', '.tif']
  }],
  ['WEBP', {
      description: 'An image format developed by Google that provides lossy and lossless compression for images on the web.',
      developer: 'Google',
      extension: ['.webp']
  }],
  ['SVG', {
      description: 'A vector image format that uses XML to describe two-dimensional graphics.',
      developer: 'World Wide Web Consortium (W3C)',
      extension: ['.svg']
  }],
  ['HEIF', {
      description: 'A container format for images and image sequences, often using HEVC for compression.',
      developer: 'Moving Picture Experts Group (MPEG)',
      extension: ['.heif', '.heic']
  }],
  ['ICO', {
      description: 'An image file format for icons in Microsoft Windows, supporting multiple sizes and color depths.',
      developer: 'Microsoft',
      extension: ['.ico']
  }],
  ['PDF', {
      description: 'A file format developed by Adobe for document exchange that can include images, text, and vector graphics.',
      developer: 'Adobe Systems',
      extension: ['.pdf']
  }],
  ['RAW', {
      description: 'A collection of unprocessed data from a camera sensor, allowing for extensive post-processing.',
      developer: 'Various manufacturers',
      extension: ['.raw', '.cr2', '.nef', '.arw', '.orf', '.dng']
  }],
  ['EXR', {
      description: 'A high dynamic range image file format used for visual effects and computer graphics.',
      developer: 'Industrial Light & Magic',
      extension: ['.exr']
  }],
  ['DNG', {
      description: 'Adobe’s open raw image format designed to store camera raw files in a standard format.',
      developer: 'Adobe',
      extension: ['.dng']
  }],
  ['TGA', {
      description: 'A raster graphics file format used for images created with Truevision Targa video cards.',
      developer: 'Truevision',
      extension: ['.tga']
  }],
  ['PBM', {
      description: 'A simple bitmap image format used for black-and-white images.',
      developer: 'Netpbm',
      extension: ['.pbm']
  }],
  ['PGM', {
      description: 'A grayscale image format that is part of the Netpbm format family.',
      developer: 'Netpbm',
      extension: ['.pgm']
  }],
  ['PPM', {
      description: 'A pixel-based image format used for color images, part of the Netpbm format family.',
      developer: 'Netpbm',
      extension: ['.ppm']
  }],
  ['XBM', {
      description: 'A bitmap image format for X11 that uses C code to describe the image.',
      developer: 'X Window System',
      extension: ['.xbm']
  }],
  ['XPM', {
      description: 'An image format that uses C code to describe a color image in the X Window System.',
      developer: 'X Window System',
      extension: ['.xpm']
  }],
  ['X', { 
    description: 'An image format used in the X Window System, often referring to X Bitmap (XBM) format, which is a monochrome bitmap image format.', 
    developer: 'X Consortium', 
    extension: ['.x'] 
  }],  
  ['AI', {
    description: 'A proprietary vector graphics format developed by Adobe Systems, primarily used for illustrations and graphic design.',
    developer: 'Adobe Systems',
    extension: ['.ai']
  }],
  ['EPS', {
      description: 'Encapsulated PostScript, a vector file format used for high-quality graphics and print production.',
      developer: 'Adobe Systems',
      extension: ['.eps']
  }],
  ['PCX', {
      description: 'An image file format that was popular in the early days of personal computing, known for its simplicity and widespread support.',
      developer: 'ZSoft Corporation',
      extension: ['.pcx']
  }],
  ['PICT', { 
    description: 'A graphics file format commonly used on Macintosh computers, which can contain both vector and bitmap images.', 
    developer: 'Apple Inc.', 
    extension: ['.pict', '.pct'] 
  }],
  ['PAL', { 
      description: 'A bitmap image format used primarily in older video games and graphics applications, often associated with the PAL video standard.', 
      developer: 'Various', 
      extension: ['.pal'] 
  }]
]);

//-- extensions
export const formatList = Array.from(imageFormats.keys());
export const formatExtensions = Array.from(imageFormats.values()).map(format => format.extension);

/** Output formats **/
export const outputFormats = [
  'AAI', 'AI', 'ART', 'AVS', 'BGR', 'BGRA', 'BGRO', 'BIE',
  'BMP', 'BMP2', 'BMP3', 'BRF', 'CAL', 'CALS', 'CIN', 'CIP',
  'CLIP', 'CMYK', 'CMYKA', 'CUR', 'DATA', 'DCX', 'DDS', 'DPX',
  'DXT1', 'DXT5', 'EPDF', 'EPI', 'EPS', 'EPS2', 'EPS3', 'EPSF',
  'EPSI', 'EPT', 'EPT2', 'EPT3', 'EXR', 'FAX', 'FITS', 'FTS',
  'G3', 'G4', 'GIF', 'GIF87', 'GRAY', 'GRAYA', 'GROUP4', 'H',
  'HDR', 'HISTOGRAM', 'HRZ', 'ICB', 'ICO', 'ICON', 'INFO', 'INLINE',
  'IPL', 'ISOBRL', 'ISOBRL6', 'JBG', 'JBIG', 'JNG', 'JPE', 'JPEG',
  'JPG', 'JPS', 'M2V', 'M4V', 'MAGICK', 'MAP', 'MASK', 'MAT',
  'MATTE', 'MIFF', 'MKV', 'MNG', 'MONO', 'MOV', 'MP4', 'MPC',
  'MPEG', 'MPG', 'MSL', 'MSVG', 'MTV', 'MVG', 'NULL', 'OTB',
  'PAL', 'PALM', 'PAM', 'PBM', 'PCD', 'PCDS', 'PCL', 'PCT',
  'PCX', 'PDB', 'PDF', 'PDFA', 'PFM', 'PGM', 'PGX', 'PICON',
  'PICT', 'PJPEG', 'PNG', 'PNG00', 'PNG24', 'PNG32', 'PNG48', 'PNG64',
  'PNG8', 'PNM', 'PPM', 'PREVIEW', 'PS', 'PS2', 'PS3', 'PSB',
  'PSD', 'PTIF', 'RAS', 'RGB', 'RGBA', 'RGBO', 'RGF', 'SGI',
  'SHTML', 'SIX', 'SIXEL', 'SPARSE-COLOR', 'SUN', 'SVG', 'SVGZ', 'TEXT',
  'TGA', 'THUMBNAIL', 'TIFF', 'TIFF64', 'UBRL', 'UBRL6', 'UIL', 'UYVY',
  'VDA', 'VICAR', 'VID', 'VIFF', 'VIPS', 'VST', 'WBMP', 'WEBP',
  'WMV', 'X', 'XBM', 'XPM', 'XV', 'XWD', 'YCBCR', 'YCBCRA', 'YUV'
];

/*
export const outputFormatOptions = () => (
  <>
    {outputFormats.map(format => (
      <Option key={format} value={format}>
        {format}
      </Option>
    ))}
  </>
);
*/

export const output_formats = [
    <option value="aai">AAI</option>,
    <option value="ai">AI</option>,
    <option value="art">ART</option>,
    <option value="avs">AVS</option>,
    <option value="bgr">BGR</option>,
    <option value="bgra">BGRA</option>,
    <option value="bgro">BGRO</option>,
    <option value="bie">BIE</option>,
    <option value="bmp">BMP</option>,
    <option value="bmp2">BMP2</option>,
    <option value="bmp3">BMP3</option>,
    <option value="brf">BRF</option>,
    <option value="cal">CAL</option>,
    <option value="cals">CALS</option>,
    <option value="cin">CIN</option>,
    <option value="cip">CIP</option>,
    <option value="clip">CLIP</option>,
    <option value="cmyk">CMYK</option>,
    <option value="cmyka">CMYKA</option>,
    <option value="cur">CUR</option>,
    <option value="data">DATA</option>,
    <option value="dcx">DCX</option>,
    <option value="dds">DDS</option>,
    <option value="dpx">DPX</option>,
    <option value="dxt1">DXT1</option>,
    <option value="dxt5">DXT5</option>,
    <option value="epdf">EPDF</option>,
    <option value="epi">EPI</option>,
    <option value="eps">EPS</option>,
    <option value="eps2">EPS2</option>,
    <option value="eps3">EPS3</option>,
    <option value="epsf">EPSF</option>,
    <option value="epsi">EPSI</option>,
    <option value="ept">EPT</option>,
    <option value="ept2">EPT2</option>,
    <option value="ept3">EPT3</option>,
    <option value="exr">EXR</option>,
    <option value="fax">FAX</option>,
    <option value="fits">FITS</option>,
    <option value="fts">FTS</option>,
    <option value="g3">G3</option>,
    <option value="g4">G4</option>,
    <option value="gif">GIF</option>,
    <option value="gif87">GIF87</option>,
    <option value="gray">GRAY</option>,
    <option value="graya">GRAYA</option>,
    <option value="group4">GROUP4</option>,
    <option value="h">H</option>,
    <option value="hdr">HDR</option>,
    <option value="histogram">HISTOGRAM</option>,
    <option value="hrz">HRZ</option>,
    <option value="icb">ICB</option>,
    <option value="ico">ICO</option>,
    <option value="icon">ICON</option>,
    <option value="info">INFO</option>,
    <option value="inline">INLINE</option>,
    <option value="ipl">IPL</option>,
    <option value="isobrl">ISOBRL</option>,
    <option value="isobrl6">ISOBRL6</option>,
    <option value="jbg">JBG</option>,
    <option value="jbig">JBIG</option>,
    <option value="jng">JNG</option>,
    <option value="jpe">JPE</option>,
    <option value="jpeg">JPEG</option>,
    <option value="jpg">JPG</option>,
    <option value="jps">JPS</option>,
    <option value="m2v">M2V</option>,
    <option value="m4v">M4V</option>,
    <option value="magick">MAGICK</option>,
    <option value="map">MAP</option>,
    <option value="mask">MASK</option>,
    <option value="mat">MAT</option>,
    <option value="matte">MATTE</option>,
    <option value="miff">MIFF</option>,
    <option value="mkv">MKV</option>,
    <option value="mng">MNG</option>,
    <option value="mono">MONO</option>,
    <option value="mov">MOV</option>,
    <option value="mp4">MP4</option>,
    <option value="mpc">MPC</option>,
    <option value="mpeg">MPEG</option>,
    <option value="mpg">MPG</option>,
    <option value="msl">MSL</option>,
    <option value="msvg">MSVG</option>,
    <option value="mtv">MTV</option>,
    <option value="mvg">MVG</option>,
    <option value="null">NULL</option>,
    <option value="otb">OTB</option>,
    <option value="pal">PAL</option>,
    <option value="palm">PALM</option>,
    <option value="pam">PAM</option>,
    <option value="pbm">PBM</option>,
    <option value="pcd">PCD</option>,
    <option value="pcds">PCDS</option>,
    <option value="pcl">PCL</option>,
    <option value="pct">PCT</option>,
    <option value="pcx">PCX</option>,
    <option value="pdb">PDB</option>,
    <option value="pdf">PDF</option>,
    <option value="pdfa">PDFA</option>,
    <option value="pfm">PFM</option>,
    <option value="pgm">PGM</option>,
    <option value="pgx">PGX</option>,
    <option value="picon">PICON</option>,
    <option value="pict">PICT</option>,
    <option value="pjpeg">PJPEG</option>,
    <option value="png">PNG</option>,
    <option value="png00">PNG00</option>,
    <option value="png24">PNG24</option>,
    <option value="png32">PNG32</option>,
    <option value="png48">PNG48</option>,
    <option value="png64">PNG64</option>,
    <option value="png8">PNG8</option>,
    <option value="pnm">PNM</option>,
    <option value="ppm">PPM</option>,
    <option value="preview">PREVIEW</option>,
    <option value="ps">PS</option>,
    <option value="ps2">PS2</option>,
    <option value="ps3">PS3</option>,
    <option value="psb">PSB</option>,
    <option value="psd">PSD</option>,
    <option value="ptif">PTIF</option>,
    <option value="ras">RAS</option>,
    <option value="rgb">RGB</option>,
    <option value="rgba">RGBA</option>,
    <option value="rgbo">RGBO</option>,
    <option value="rgf">RGF</option>,
    <option value="sgi">SGI</option>,
    <option value="shtml">SHTML</option>,
    <option value="six">SIX</option>,
    <option value="sixel">SIXEL</option>,
    <option value="sparse-color">SPARSE-COLOR</option>,
    <option value="sun">SUN</option>,
    <option value="svg">SVG</option>,
    <option value="svgz">SVGZ</option>,
    <option value="text">TEXT</option>,
    <option value="tga">TGA</option>,
    <option value="thumbnail">THUMBNAIL</option>,
    <option value="tiff">TIFF</option>,
    <option value="tiff64">TIFF64</option>,
    <option value="ubrl">UBRL</option>,
    <option value="ubrl6">UBRL6</option>,
    <option value="uil">UIL</option>,
    <option value="uyvy">UYVY</option>,
    <option value="vda">VDA</option>,
    <option value="vicar">VICAR</option>,
    <option value="vid">VID</option>,
    <option value="viff">VIFF</option>,
    <option value="vips">VIPS</option>,
    <option value="vst">VST</option>,
    <option value="wbmp">WBMP</option>,
    <option value="webp">WEBP</option>,
    <option value="wmv">WMV</option>,
    <option value="x">X</option>,
    <option value="xbm">XBM</option>,
    <option value="xpm">XPM</option>,
    <option value="xv">XV</option>,
    <option value="xwd">XWD</option>,
    <option value="ycbcr">YCBCR</option>,
    <option value="ycbcra">YCBCRA</option>,
    <option value="yuv">YUV</option>
  ];

// export default { imageFormats ,formatList ,formatExtensions ,outputFormats ,outputFormatOptions ,output_formats }